import styles from './MaintenancePage.module.less';
import cx from 'classnames';

export default function MaintenancePage() {
  return (
    <div className={cx('scroll-box', styles.page)}>
      <div className={styles.frame}>
        <div className={styles.box}>
          <div className={styles.image}></div>
          <div className={styles.info}>
            <h1>Maintenance Mode</h1>
            <div>
              Our site is offline for planned maintenance. We will be back up shortly.

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


